var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-1",attrs:{"item-key":"name","loading":"","loading-text":"Loading... Please wait"}})}
var staticRenderFns = []

export { render, staticRenderFns }